import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  holidaysMode: "none",
  drawer: false,
  showChat: false,
  showSettings: false,
  unreadMessages: 0,
  users: [],
  reaperVictim: "none",
  serverVictim: "none",
  selectedStyle: 'avataaars',
  avatarBackground: '#65c9fe',
  avatarStyles: [
    '',
    'adventurer',
    // 'adventurer-neutral',
    'avataaars',
    'big-ears',
    // 'big-ears-neutral',
    'big-smile',
    'bottts',
    'croodles',
    'fun-emoji',
    // 'croodles-neutral',
    'identicon',
    'micah',
    'miniavs',
    'open-peeps',
    'personas',
    'pixel-art',
    'shapes',
    'thumbs'
  ]
}

const mutations = {
  toggleDrawer () {
    state.drawer = !state.drawer
  },
  disableDrawer() {
    state.drawer = false
  },
  setAvatarStyle(state, value) {
    state.selectedStyle = value;
  },
  increaseUnreadMessages() {
    state.unreadMessages = state.unreadMessages + 1;
  },
  resetUnreadMessages() {
    state.unreadMessages = 0;
  },
  toggleChat() {
    state.showChat = !state.showChat;
  },
  toggleSettings() {
    state.showSettings = !state.showSettings;
  },
  chooseRandomVictim(state) {
    const victim = state.users[Math.floor(Math.random() * state.users.length)];
    state.reaperVictim = victim;
  },
  syncVictim(state) {
    state.reaperVictim = state.serverVictim;
  },
  resetVictim() {
    state.reaperVictim = "none";
  },
  setServerVictim(state, value) {
    state.serverVictim = value;
  },
  updateUsers: function(state, value) {
    state.users = value;
  },
  setAvatarBackground: function(state, value) {
    state.avatarBackground = value
  },
  setHolidaysMode: function(state, value) {
    state.holidaysMode = value;
  }
}

export default new Vuex.Store({
  state,
  mutations
})